import { useRef, useEffect } from "react";

function CenteredModal({
                           show,
                           modalType = "",
                           title,
                           children,
                           onClose,
                           onConfirm,
                           confirmText = "Save Changes",
                           closeText = "Cancel",
                           formId,
                           disabledConfirmBtn = false,
                           isViewMode = false,
                           modalHeight,
                           isSubmitting = false,
                           modalContentClass = ""
}) {
    const modalRef = useRef();
    useEffect(() => {
        if (!show) return;
        const modalElement = modalRef.current;
        const bsModal = new window.bootstrap.Modal(modalElement, {
            backdrop: "static",
            keyboard: false
        });
        bsModal.show();
        return () => {
            bsModal.hide();
        };
    }, [show]);

    if (!show) return null;
    return (
        <div className="modal fade" tabIndex="-1" ref={modalRef} style={{ display: show ? "block" : "none" }}>
            <div className={`modal-dialog modal-dialog-centered ${modalType}`}>
                <div className={`modal-content ${modalContentClass}`} style={modalHeight ? { height: modalHeight, overflowY: 'auto' } : {}}
                >
                    {
                        title &&
                        (
                            <div className="modal-header">
                                <h5 className="modal-title">{title}</h5>
                                <button type="button" className="btn-close" onClick={onClose}></button>
                            </div>
                        )
                    }
                    <div className='modal-body'>{children}</div>
                    {
                        closeText && (
                            <div className="modal-footer">
                                {!isViewMode && (onConfirm || formId) && (
                                    <button disabled={disabledConfirmBtn || isSubmitting}
                                            type={formId ? "submit" : "button"}
                                            {...(formId && { form: formId })}
                                            className="btn btn-bt-primary" {...(!formId && { onClick: onConfirm })}
                                    >
                                        {
                                            isSubmitting && (
                                                <span role="status" aria-hidden="true" className="spinner-border spinner-border-sm me-3"></span>
                                            )
                                        }
                                        {isSubmitting ? "Processing..." : confirmText}
                                    </button>
                                )}
                                <button type= "button"  className="btn btn-bt-secondary" onClick={onClose}>
                                    {closeText}
                                </button>
                            </div>
                        )
                    }
                </div>
            </div>
        </div>
    );
}

export default CenteredModal;
